import React from 'react';
import Image from 'components/Image';
import { MostReadFragment } from 'gql/graphql-operations';
import Link from 'next/link';
import extractText from 'utilities/src/extractText';

type MostReadProps = {
  posts?: (MostReadFragment | null | undefined)[] | null;
};

export default function MostRead({ posts }: MostReadProps) {
  const resultSlice = (text: string | null | undefined) =>
    text && text.length > 80 ? `${text.slice(0, 84)}...` : text;
  return (
    <aside id="most-read-this-week" className="mdL:w-[24rem] mdL:flex-none">
      <h2 className="text-site-neutrals-500 lgS:pb-6 site-overline-m block pb-6 font-bold">Latest posts</h2>
      <ul className="mdL:flex mdL:gap-0 flex flex-col md:grid md:grid-cols-2 md:gap-6">
        {posts?.map((post) => (
          <li
            key={`most-read-${post?.id}`}
            className="bg-site-neutrals-25 mdL:last:block mb-4 last:mb-0 md:last:hidden"
          >
            <Link href={post?.slug ?? ''} className="flex items-center [&_div_h3]:hover:underline">
              <figure className="relative h-[6rem] w-[7.75rem] flex-1">
                <Image
                  src={post?.featuredImage?.node?.mediaDetails?.file ?? ''}
                  alt={post?.featuredImage?.node?.altText ?? 'Post Image'}
                  fill
                  className="object-cover object-center"
                  sizes="8rem"
                />
              </figure>
              <div className="w-[calc(100%-125px-1rem)] p-3">
                <h3 className="site-paragraph-m text-site-neutrals-600 break-words font-normal">
                  {resultSlice(extractText(post?.title))}
                </h3>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
